// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

// load fonts
// WebFont.load({
//     google: { // add &display=swap to end of ONLY last font family
//         families: ['Roboto:400,500,700&display=swap']
//     },
//     //,
//     // typekit: {
//     // id: 'XXXX'
//     // },
//     active: function() { // helps stop flash of unstyled text
//         sessionStorage.fontsLoaded = true 
//     }
// });

// Load BS
require('bootstrap');

//Load Libraries
require('flatpickr/dist/flatpickr.min');
require('magnific-popup/dist/jquery.magnific-popup.min');
require('objectFitPolyfill/dist/objectFitPolyfill.min');
require('select2/dist/js/select2.full.min');
require('slick-slider/slick/slick.min');
require('masonry-layout/dist/masonry.pkgd.min');
require('imagesloaded/imagesloaded.pkgd.min');

//Load Modules
require('./modules/accordion');
require('./modules/animatein');
require('./modules/bannerVideo');
require('./modules/formInputs');
require('./modules/localVideoBlock');
require('./modules/menu');
require('./modules/modal');
require('./modules/scrollTo');
require('./modules/shareSocial');
require('./modules/sideMenu');
require('./modules/tabs');
require('./modules/inlineVideo');
require('./modules/showcaseLocalVideoBlock');
require('./modules/blogFilters');

// highlight related label when input in focus
$("form :input").focus(function(){
    $("label[for='" + this.id +"']").addClass("__labelfocus");
}).blur(function(){
    if($(this).val().length < 1){
        $("label[for='" + this.id +"']").removeClass("__labelfocus");
    }
});

/* footer menu */
$(function() {
    var toggle = $('.footermenuToggle');
    toggle.click(function() {
        event.preventDefault();
        $(this)
            .parent()
            .toggleClass('__active');
        $(this)
            .siblings()
            .slideToggle();
    });
});
